import React, { useState, useEffect } from "react";
import {
  Button,
  MenuItem,
  Select,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputBase,
  IconButton,
} from "@material-ui/core";
import swal from "sweetalert";
import apiClient from "../../api/client";
import { useLocation, useNavigate } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import "./AddService.css";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(1),
  },
}));

const UpdatePackage = () => {
  const loc = useLocation();

  const intialState = {
    jobs: loc.state.details,
  };
  const [file2, setFile2] = useState([]);

  const [jobsData, setJobsData] = useState(intialState);

  const navigate = useNavigate();
  const classes = useStyles();

  const [state, setState] = useState({
    name: loc.state.name,

    image: loc.state.image,
    description: loc.state.description,
    hotel: loc.state.hotel,
    days: loc.state.days,
    details: [],
    priceChild: loc.state?.priceChild,
    priceInfant: loc.state?.priceInfant,

    price: loc.state.price,
    discount: loc.state.discount,

    notes: "",
  });

  const uploadFileHandler = async (e) => {
    setFile2([...file2, ...e.target.files]);
  };

  function handleChange(event) {
    const { name, value } = event.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    // if (file2.length < 1) {
    //   swal("Please select image");
    // } else {
    swal({
      title: "Are you sure?",
      text: "You want to Update Service",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        // if (file2) {
        // const formData = new FormData();

        // for (const file of file2) {
        //   formData.append("image", file, file.name);
        // }

        // const config = {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        // };
        // const { data } = await apiClient.post(
        //   "/uploadImages/uploadImages",
        //   formData,
        //   config
        // );
        
        // if (data) {
          const result1 = await apiClient.post("/package/update", {
            name: state.name,
            id: loc.state._id,
            image: loc.state.image,
            hotel: state.hotel,
            days: state.days,
            price: state.price,
            priceChild: state.priceChild,
            priceInfant: state.priceInfant,
            discount: state.discount,

            notes: state.notes,
            description: state.description,

            details: jobsData.jobs,
          });

          if (result1.ok) {
            setState({
              name: "",
              hotel: "",
              image: "",
              description: "",
              days: "",
              details: "",

              price: "",
              discount: "",
              priceInfant: "",
                  priceChild: "",

              notes: "",
            });
            setFile2([]);
            swal("Success package updated");
            navigate("/package/all");
          } else {
            swal(
              "Service Upload failed due to network issue or missing fields"
            );
          }
        // } else {
          // swal("Service upload Failed. Please Try again!!!!!");
          // navigate("/service/all");
        // }
      }
      // }
    });
    // }
  };

  const handleChange2 = (index, e) => {
    const values = [...jobsData.jobs];
    values[index] = e.target.value;
    setJobsData({ ...jobsData, jobs: values });
  };

  const handleAddField = (e) => {
    e.preventDefault();
    setJobsData((prevState) => ({
      ...prevState,
      jobs: [...prevState.jobs, ""],
    }));
  };

  const handleRemoveField = (index) => {
    const values = jobsData.jobs;
    values.splice(index, 1);
    setJobsData((prevState) => ({ ...prevState, values }));
  };

  return (
    <div id="layoutSidenav_content">
      <main>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5 col-md-9 col-lg-6">
              <h2 className="mt-30 page-title">Packages</h2>
            </div>
            <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
              <Button variant="contained" onClick={(e) => this.handleBack()}>
                <i class="fas fa-arrow-left" /> Back
              </Button>
            </div>
          </div>
          <ol className="breadcrumb mb-30">
            <li className="breadcrumb-item">
              <a href="/">Dashboard</a>
            </li>
            <li className="breadcrumb-item">
              <a href="/admin/product/create">Packages</a>
            </li>
            <li className="breadcrumb-item active">Add Package</li>
          </ol>

          {/* Add prd  */}
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="card card-static-2 mb-30">
                <div className="card-title-2">
                  <h4>Add New Package</h4>
                </div>
                <div className="card-body-table">
                  <div className="news-content-right pd-20">
                    <div className="row">
                      <div className="col-lg-3 col-md-2">
                        <div className="form-group">
                          <label className="form-label">Package Title*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Product Name"
                            name="name"
                            value={state.name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <br />

                    <div className="col-lg-8 col-md-2 mt-3">
                      <div className="form-group">
                        <label className="form-label">Description*</label>
                        <input
                          style={{ overflow: "scroll" }}
                          type="text"
                          className="form-control"
                          placeholder="Product Description"
                          name="description"
                          value={state.description}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-8 col-md-2 mt-3">
                      <div className="form-group">
                        <div>
                          <TableContainer
                            component={Paper}
                            className="tb-container"
                          >
                            <Table
                              className={classes.table}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell>Details</TableCell>
                                  <TableCell>Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {jobsData?.jobs?.map((itemField, index) => (
                                  <TableRow key={index}>
                                    <TableCell align="left">
                                      <InputBase
                                        sx={{ ml: 1, flex: 1 }}
                                        type="text"
                                        name="name"
                                        onChange={(e) =>
                                          handleChange2(index, e)
                                        }
                                        value={itemField}
                                        placeholder="Detail"
                                      />
                                    </TableCell>

                                    <TableCell align="left">
                                      <IconButton
                                        onClick={() => handleRemoveField(index)}
                                      >
                                        <DeleteOutlinedIcon
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <div className="addButton">
                            <button onClick={handleAddField}>+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-2 col-md-2 mt-3">
                        <div className="form-group">
                          <label className="form-label">Price*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Adult's Price"
                            name="price"
                            value={state.price}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-2 mt-3">
                        <div className="form-group">
                          <label className="form-label">Child's Price*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Child's Price"
                            name="priceChild"
                            value={state.priceChild}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-2 mt-3">
                        <div className="form-group">
                          <label className="form-label">Infant's Price*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Infant's Price"
                            name="priceInfant"
                            value={state.priceInfant}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-lg-2 col-md-2 mt-3">
                        <div className="form-group">
                          <label className="form-label">Discount*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Product Disount"
                            name="discount"
                            value={state.discount}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-2 col-md-2 mt-3">
                        <div className="form-group">
                          <label className="form-label">Hotel*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Hotel"
                            name="hotel"
                            value={state.hotel}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-2 mt-3">
                        <div className="form-group">
                          <label className="form-label">Days*</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Number of days"
                            name="days"
                            value={state.days}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-2 mt-3">
                      <div className="form-group">
                        <label className="form-label">Notes*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Notes"
                          name="notes"
                          value={state.notes}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body-table">
                  <div className="news-content-right pd-20">
                    <button
                      className="save-btn hover-btn"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Update Service
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UpdatePackage;
